import { observable, computed, runInAction } from 'mobx';
import { get } from '../utils';

class RankOrder {
    static PAGE_SIZE = 10;
    private route: string;
    private params: any;

    @observable
    public firstFetched: boolean = false;
    @observable
    public isEmpty: boolean = false;
    @observable
    public lists: any[] = [];
    @observable
    public page: any = 1;
    @observable
    public cursor: any = 0;// 是否有下一页

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    updateParams(key, val) {
        this.params[key] = val;
    }

    @observable
    private isLastPage: boolean = true;


    @computed
    get canFetch() {
        if (this.isEmpty) {
            return false;
        }
        return !this.isLastPage;
    }

    fetch(page, callback, errs?) {
        var obj = Object.assign({
            limit: RankOrder.PAGE_SIZE,
            cursor: this.cursor
        }, this.params);
        if (page == 1) {
            obj.cursor = 0;
        }
        get(this.route, obj).then((d) => {
            let data;
            if (d.errCode != 200) {
                errs && errs(d.errCode);
                return;
            } else {
                data = d.data.list;
                this.cursor = d.data.cursor;
                callback && callback(data, this.cursor);
                this.firstFetched = true;
                runInAction(() => {
                    if (page == 1) {
                        this.lists = [];
                        this.isEmpty = data.length == 0;
                    }
                    this.firstFetched = true;
                    this.isLastPage = data.length < RankOrder.PAGE_SIZE;
                    data.forEach((item) => {
                        item.key = item.ciId + '' + Date.now();
                        this.lists.push(item);
                    });
                });
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    @computed
    get list() {
        return this.lists.slice();
    }
}

export default RankOrder;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/RankOrder.ts